<template>
  <div class="content flex-box" v-if="activity">
    <data-list
      ref="dataList"
      class="flex-grow"
      url="/activity/activity-driver"
      entity-name="司机"
      add-btn="添加司机"
      hide-show-detail
      :hide-action="!editable"
      :custom-url="customUrl"
      :before-update="beforeUpdate"
      :query="query"
      :action="action"
      :columns="columns"
      :rules="rules">
      <template v-slot:button v-if="editable">
        <a-button @click="importDriver"><a-icon type="upload" />批量导入</a-button>
      </template>
      <template v-slot:query="{form}">
        <a-form-model-item label="">
          <a-input v-model="form.keyword" placeholder="输入司机姓名或手机号查询" style="width: 200px"></a-input>
        </a-form-model-item>
      </template>
      <template v-slot:edit="{form}">
        <a-form-model-item label="姓名" prop="name">
          <a-input v-model="form.name" placeholder="请输入司机姓名"></a-input>
        </a-form-model-item>
        <a-form-model-item label="手机号码" prop="tel">
          <a-input v-model="form.tel" placeholder="请输入司机手机号码"></a-input>
        </a-form-model-item>
      </template>
    </data-list>
    <batch-import-modal
      v-model="visible"
      name="司机导入模板.xlsx"
      url="https://lingyin-1301841918.cos.ap-shanghai.myqcloud.com/assets/activity/template/driver_template.xlsx"
      import-url="/activity/activity-driver/driver-import"
      :activity="activity.id * 1"
      @import="handleImport"></batch-import-modal>
  </div>
</template>

<script>
    import batchImportModal from "../../../components/batch-import-modal";
    import {driverColumns} from "../../../common/activity/vehicle";
    import mixins from "../mixins";

    export default {
        name: "ActivityDriver",
        components: {
            batchImportModal
        },
        mixins: [mixins],
        data() {
            return {
                columns: driverColumns,
                rules: {
                    name: [{ required: true, message: '请输入司机姓名', trigger: 'blur' }],
                    tel: [
                        { required: true, message: '请输入司机手机号码', trigger: 'blur' },
                        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                    ]
                },
                visible: false,
                moduleKey: 'traffic-driver',
            }
        },
        computed: {
            action() {
                return this.editable ? ['add', 'delete', 'update', 'query', 'audit'] : ['query'];
            },
            activity() {
                return this.$store.getters.activity;
            },
            query() {
                let res = '';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            }
        },
        methods: {
            customUrl(form) {
                let res = '';
                if(form.keyword) {
                    res = `&filter[or][0][name][like]=${form.keyword}&filter[or][1][tel][like]=${form.keyword}`;
                }
                return res;
            },
            beforeUpdate(form, fn) {
                if(!form.id) {
                    form.activity_id = this.activity.id;
                }
                fn();
            },
            importDriver() {
                this.visible = true;
            },
            handleImport() {
                this.visible = false;
                this.$refs.dataList.getList();
            },
        }
    }
</script>

<style scoped lang="less">
</style>
